import {Pipe, PipeTransform} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

import {map, Observable} from "rxjs";

@Pipe({
  name: 'secureImage'
})
export class SecureImagePipe implements PipeTransform {

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
  }

  transform(url: string): Observable<SafeUrl> {
    return this.http.get(url, {responseType: 'blob'}).pipe(
      map(x => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(x))));
  }

}
